// MARK://dhk8/pos/lib/clients/invoice-attempts
// Lane #175.B.1 — lector del audit trail de intents de facturación.
//
// El portal público (dhk8-public-tickets) escribe 1 row por cada paso del
// flow factura-por-QR (ticket abierto, form enviado, contact upserted, stamp
// success/error) en `dhk8_fiscal.invoice_request_logs` vía el endpoint
// `POST /v1/dhk8-fiscal-cfdi/v1/invoice-attempts`.
//
// El POS lee esos rows con `GET /v1/invoice-attempts?posOrderId=...` para
// mostrar el timeline al staff en `/tickets/:orderId`. El error técnico
// del SAT (CFDI40143, etc.) que el cliente NUNCA vio queda visible aquí
// para que soporte pueda actuar.

import { apiData, svcUrl } from '../api.js'

export type InvoiceAttemptStage =
  | 'ticket_viewed'
  | 'invoice_form_submitted'
  | 'contact_upserted'
  | 'stamp_success'
  | 'stamp_error'
  | 'system_error'

export interface InvoiceAttemptDto {
  id: string
  tenantId: string
  posOrderId: string | null
  publicTicketUuid: string | null
  stage: InvoiceAttemptStage
  receptorJson: {
    rfc?: string
    razonSocial?: string
    regimen?: string
    usoCfdi?: string
    cp?: string
    email?: string
  } | null
  cfdiUuid: string | null
  errorCode: string | null
  errorMessage: string | null
  env: 'live' | 'test' | null
  userAgent: string | null
  ipAddress: string | null
  fiscalEntityId: string | null
  contactId: string | null
  createdAt: string
}

const BASE = svcUrl('dhk8-fiscal-cfdi', '/v1/invoice-attempts')

export async function listInvoiceAttempts(
  args: { posOrderId?: string; publicTicketUuid?: string; limit?: number },
  signal?: AbortSignal,
): Promise<InvoiceAttemptDto[]> {
  const qs = new URLSearchParams()
  if (args.posOrderId) qs.set('posOrderId', args.posOrderId)
  if (args.publicTicketUuid) qs.set('publicTicketUuid', args.publicTicketUuid)
  if (args.limit) qs.set('limit', String(args.limit))
  const url = `${BASE}?${qs.toString()}`
  const res = await apiData<{ items: InvoiceAttemptDto[] }>(url, { signal })
  return res.items ?? []
}
